"use client";

import Modal from "@/components/ui/modal";
import AllCommunityMembers from "./all-members";

type TCommunityMembersModalProps = {
	open: boolean;
	setOpen: (state: boolean) => void;
};

const CommunityMembersModal = ({ open, setOpen }: TCommunityMembersModalProps) => {
	return (
		<Modal isOpen={open} onClose={() => setOpen(false)} className="max-w-4xl">
			<AllCommunityMembers />
		</Modal>
	);
};

export default CommunityMembersModal;
